import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "eyeClosedFilled"
const EyeClosedFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M2.993 2.682 2.989 2.687 21.526 21.223 20.47 22.28 16.01 17.82C14.824 18.388 13.484 18.75 12 18.75 5.25 18.75 1.5 11.25 1.5 11.25S2.698 8.853 4.96 6.77L1.72 3.53 2.78 2.47zM6.02 7.832Q5.646 8.175 5.306 8.533C4.494 9.388 3.87 10.248 3.45 10.896Q3.325 11.087 3.226 11.25 3.326 11.413 3.45 11.604C3.869 12.253 4.494 13.113 5.306 13.968 6.953 15.7 9.211 17.25 12 17.25 13.031 17.25 13.99 17.037 14.872 16.682L13.042 14.852C12.71 14.947 12.362 15 12 15 9.929 15 8.25 13.321 8.25 11.25 8.25 10.888 8.302 10.539 8.397 10.208z"
            clipRule="evenodd"
          />
          <path d="M12 3.75C18.75 3.75 22.5 11.25 22.5 11.25S21.133 13.978 18.568 16.144L17.503 15.079C17.929 14.727 18.327 14.352 18.693 13.967 19.507 13.112 20.13 12.252 20.552 11.604Q20.675 11.414 20.773 11.25 20.674 11.087 20.55 10.896C20.131 10.248 19.506 9.388 18.694 8.533 17.047 6.8 14.789 5.25 12 5.25 10.725 5.25 9.561 5.574 8.516 6.092L7.404 4.98C8.73 4.245 10.266 3.75 12 3.75" />
          <path d="M12 7.5C14.071 7.5 15.75 9.179 15.75 11.25 15.75 11.854 15.605 12.423 15.352 12.928L10.32 7.897C10.826 7.643 11.396 7.5 12 7.5" />
        </svg>
      }
    </span>
  )
}
export default EyeClosedFilledIcon
